import { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import MobileBlogCarousel from './mobile-blog-carousel.component';

import DesktopBlogCarousel from './desktop-blog-carousel.component';

import { cmsService } from '../../services/homii-services';

const BlogSection = (props) => {

    const { page, title, showAll, tagId, pageSize } = props;

    const [blogData, setBlogData] = useState(null);

    useEffect(() => {
        const getBlogs = async () => {            
            const respBlog = await cmsService.ListWordPressBlogPosts(pageSize, pageSize, tagId);
            setBlogData(_.get(respBlog, 'blogs'));
        };
        getBlogs();
    }, [page]);

    if (!blogData) {
        return null;
    }

    return (
        <div className='blog-section'>
            <MobileBlogCarousel data={blogData} title={title} showAll={showAll} />
            <DesktopBlogCarousel data={blogData} title={title} showAll={showAll} />
        </div>
    );
};

export default BlogSection;

BlogSection.propTypes = {
    page: PropTypes.any,
    title: PropTypes.string,
    showAll: PropTypes.bool,
    tagId: PropTypes.number,
    pageSize: PropTypes.number,
};


